import { formField } from 'framework/components/hoc/formField';
import { NumericField } from './NumericField';

const NumericFieldComponent = formField(NumericField);

export default NumericFieldComponent;
